<template>
    <div>
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240)"
            :ghost="false"
            title="Report"
            sub-title="Nilai Klasikal Rata-Rata Peserta Per Materi Pelatihan"
            @back="back">

            <common-training-header :withLocation="true"/>
        </a-page-header>
        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table
                class="pcp-table"
                :dataSource="tableData"
                rowKey="hash"
                :pagination="false"
                bordered>

                <a-table-column key="module" title="Module Latihan" className="align-center text-small text-left" width="80%">
                    <template slot-scope="record">
                        <template v-if="record.is_heading">
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            <span style="padding-left: 20px;">{{ record.name }}</span>
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="resume_score" title="Nilai Resume" className="align-center text-small text-center">
                    <template slot-scope="record" v-if="! record.is_heading">
                        <h3><strong>{{ record.resume_score }}</strong></h3>
                    </template>
                </a-table-column>

                <a-table-column key="exam_score" title="Nilai Ujian" className="align-center text-small text-center">
                    <template slot-scope="record" v-if="! record.is_heading">
                        <h3><strong>{{ record.exam_scrore }}</strong></h3>
                    </template>
                </a-table-column>
            </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const materi = {
    id: 1,
    is_heading: false,
    name: null,
    resume_score: 0,
    exam_scrore: 0,
}

export default {
    data() {
        return {
            loading: false,
            items: {},
        }
    },
    computed: {
        tableData() {
            let collection = []
            let num = 1

            if(this.items.length > 0){
                this.items.forEach(item => {
                    collection.push(Object.assign(Object.create(materi), {
                        id: num++,
                        is_heading: true,
                        name: item.name,
                        resume_score: 0,
                        exam_scrore: 0
                    }))

                    item.materials.forEach(function (item, index) {
                        collection.push(Object.assign(Object.create(materi), {
                            id: num++,
                            is_heading: false,
                            name: item.name,
                            resume_score: item.avg_resume,
                            exam_scrore: item.avg_exam
                        }))
                    })
                })
            }

            return collection
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http.get(this.routeUri('api.report.classical.material_avg'))
                .then(response => (this.items = response.data.material_scores))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        }
    },
}
</script>
